import tray from './tray.yaml'

export default {
  tray,
}
